import { useQuery } from '@tanstack/react-query';

import { useMemberhubApi } from '../api';
import { memberhubKeys } from '../query-key-factory';
import { Family } from './families.types';

const useShowFamily = ({
  familyId,
  organizationId,
}: {
  familyId: string;
  organizationId: string;
}) => {
  const MemberhubApi = useMemberhubApi();

  const getFamily = async () => {
    const { data } = await MemberhubApi.get<{ family: Family }>(
      `/families/${familyId}?organization_uuid=${organizationId}`
    );
    return data.family;
  };

  const key = memberhubKeys.organizations.id(organizationId).families.id(familyId).all;
  return useQuery({
    queryKey: key,
    queryFn: getFamily,
    enabled: !!organizationId && !!familyId,
  });
};

const useListFamilies = ({
  userId,
  organizationId,
}: {
  userId?: string;
  organizationId?: string;
}) => {
  const MemberhubApi = useMemberhubApi();

  const get = async () => {
    const { data } = await MemberhubApi.get<{ families: Family[] }>(
      `/families?user=${userId}&organization_uuid=${organizationId}`
    );
    return data;
  };

  const key =
    organizationId && userId
      ? memberhubKeys.organizations.id(organizationId).families.users(userId).all
      : [];
  return useQuery({
    queryKey: key,
    queryFn: get,
    enabled: !!userId && !!organizationId,
  });
};

export { useListFamilies, useShowFamily };
